import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

export const ScrollToTop: FC = () => {
  const ref = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    if (ref.current !== pathname) {
      window.scrollTo(0, 0);
      ref.current = pathname;
    }
  }, [pathname]);

  return <Outlet />;
};
